import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    searchBarDividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
    },
    divider: {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      width: '0.5px',
    },
    quickFilterText: {
      display: 'inline-block',
      textAlign: 'right',
    },
    quickFilterGrid: {
      alignSelf: 'center',
    },
    statusGrid: {
      paddingLeft: 8,
      alignSelf: 'center',
    },
    stampingGrid: {
      paddingLeft: 8,
      alignSelf: 'center',
      marginRight: 16,
    },
    downloadIcon: {
      alignSelf: 'center',
      paddingRight: 4,
      cursor: 'pointer',
    },
    filterbutton: {
      '& .buttonWhenNotContained': {
        borderRadius: '27px',
        color: '#6CD9C7',
        height: 32,
        backgroundColor: 'rgba(39, 126, 126, 0.19)',
      },
      '& .buttonWhenContained': {
        borderRadius: '27px',
        color: MaterialPalette.common.white,
        height: 32,
        backgroundColor: '',
      },
    },
    diverderGrid: {
      alignSelf: 'center',
      height: 32,
    },
    searchField: {
      alignSelf: 'center',
      marginLeft: 16,
      '& .searchTextbox': {
        backgroundColor: '#121212',
        width: 215,
      },
    },
  }),
);

export default useStyles;
